import React from "react";


import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './Subtransaction.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";

import { Link } from "react-router-dom";

class ReviewMoneyTransfer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: ''
		}
	}





	componentDidMount() {



	}
	componentWillUnmount() {
	}





	render() {

		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">


							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Review - Money Transfer</h3>
												<div class="headbtn">
													<Link to='/money-transfer'>
														<button class="dbbtn" type="button">Back</button>
													</Link>

												</div>
											</div>

											<div class="accountreview">
												<div class="row">
													<div class="col-12 col-md-5">
														<div class="bankdtl">
															{/* <img src="images/icici-bank.png" alt="bank"> */}
															<h5>Ramesh Narayan Swamy</h5>
															<p>ICICI Bank Ltd</p>
														</div>
													</div>

													<div class="col-6 col-md-4">
														<div class="bankdtl">
															<h5>Account Number</h5>
															<p>1234567890243</p>
														</div>
													</div>

													<div class="col-6 col-md-3">
														<div class="bankdtl rtxt">
															<h5>IFSC Code</h5>
															<p>ICICI0003236</p>
														</div>
													</div>
												</div>
											</div>

											<div class="payreview">
												<div class="row">
													<div class="col-12 col-md-4 col-lg-2">
														<div class="payamt">
															<p>Transfer Amount</p>
															<h4>₹ {this.props.amount}</h4>
														</div>
													</div>

													<div class="col-5 col-md-4 col-lg-2">
														<div class="surcharge">
															<p>Surcharge</p>
															<h5>₹ 0.00</h5>
														</div>
													</div>

													<div class="col-7 col-md-4 col-lg-2">
														<div class="totalamt rtxt">
															<p>Total Amount</p>
															<h4>₹ {this.props.transferTotalAmount}</h4>
														</div>
													</div>
												</div>
											</div>

											<div class="dashform">


												<Link to='/money-transfer-details'>
													<button type="button" class="btn btn-primary">Transfer Now</button>
												</Link>


											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone } }
) => ({
	errorMessage, loginErrorMessage, phone
});

export default connect(mapStateToProps, null)(ReviewMoneyTransfer);
